<template>
    <div>
        <form ref="form">
            <div class="flex items-center py-md" @click.self="toggled = ! toggled">
                <checkbox-input
                    v-model="completed"
                    v-tooltip.top.start="unableToCompleteMessage"
                    :disabled="task.media.length < 1 || ! task.can_be_completed"
                    @toggle="toggleCompleted"
                >
                    {{ task.body }}
                </checkbox-input>

                <div class="ml-auto flex items-center">
                    <task-completed-by
                        :task="task"
                        class="mr-md"
                    />

                    <font-awesome-icon
                        v-if="toggled"
                        icon="chevron-up"
                        @click="toggled = ! toggled"
                    />
                    <font-awesome-icon
                        v-else
                        icon="chevron-down"
                        @click="toggled = ! toggled"
                    />
                </div>
            </div>

            <div v-show="toggled" class="pb-md">
                <div>
                    <div class="flex ml-auto rounded py-lg">
                        <input
                            ref="fileInput"
                            type="file"
                            name="image"
                            accept=".jpg,.jpeg,.png"
                            class="hidden"
                            @change="uploadMedia"
                        >

                        <button
                            type="button"
                            class="btn btn-md is-primary w-full"
                            @click="$refs.fileInput.click()"
                        >
                            Ladda upp bild
                        </button>
                    </div>

                    <h3 class="headline-md mt-md">
                        Uppladdade bilder:
                    </h3>
                    <div class="flex flex-wrap px-md">
                        <div v-for="image in task.formatted_files" class="w-1/2">
                            <div class="relative">
                                <button
                                    v-if="! isSigned"
                                    type="button"
                                    class="absolute pin-r bg-white p-sm btn-icon"
                                    @click.stop="destroy(image)"
                                >
                                    <font-awesome-icon icon="trash-alt" class="text-xs" />
                                </button>
                                <img
                                    :src="image.thumb_url"
                                    class="mb-md mx-auto block"
                                >
                                <p v-if="image.note">
                                    &ldquo;{{ image.note }}&rdquo;
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import BaseType from './BaseType';

    export default {
        extends: BaseType,
        data() {
            return {
                toggled: false,
            };
        },
        watch: {
            task(task) {
                if (task.formatted_files.length === 0 && task.completed_at !== null) {
                    this.unComplete();
                }
            },
        },
        methods: {
            toggleCompleted(isChecked) {
                if (! isChecked) {
                    return this.unComplete();
                }

                this.complete();
            },
            async complete() {
                this.completed = await this.completeTask();
            },
            async unComplete() {
                this.completed = ! await this.unCompleteTask();
            },
            async destroy(media) {
                this.deleteMedia(media, 'bilden');
            },
        },
    };
</script>
